import { useCallback, useState } from 'react';

export const usePhieuKeToanImport = () => {
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);
  const [isLoadingImport, setIsLoadingImport] = useState(false);

  const openImportDialog = useCallback(() => {
    setIsImportDialogOpen(true);
  }, []);

  const closeImportDialog = useCallback(() => {
    setIsImportDialogOpen(false);
  }, []);

  const toggleImportDialog = useCallback(() => {
    setIsImportDialogOpen(prev => !prev);
  }, []);

  return {
    isImportDialogOpen,
    isLoadingImport,
    openImportDialog,
    closeImportDialog,
    toggleImportDialog,
    setIsImportDialogOpen,
    setIsLoadingImport
  };
};
